// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prev_next__headers {
  text-align: center;
  gap: 10px;
  font-size: 18px;
  margin-bottom: 3rem;
}
.prev_next__headers .prev_next__headers_container {
  min-width: 150px;
}
.prev_next__headers .prev_next__headers_container > :not(.active) {
  display: none;
}
.prev_next__headers svg:hover {
  color: var(--primary-color);
}
.prev_next__headers svg:first-child {
  rotate: 90deg;
}
.prev_next__headers svg:last-child {
  rotate: -90deg;
}

.prev_next__contents {
  width: 100%;
  text-align: center;
  max-width: 720px;
}
.prev_next__contents > * {
  gap: 40px;
}
.prev_next__contents > * .mobile-overlay {
  z-index: 1;
}
.prev_next__contents .prev_next__content {
  position: absolute;
  z-index: 0;
  inset: 0;
}

:host ::ng-deep .mobile-overlay .image-container {
  aspect-ratio: 375/848;
  padding-bottom: 0;
}
:host ::ng-deep .prev_next__content {
  position: absolute;
  z-index: 0;
  inset: 0;
}
:host ::ng-deep .prev_next__content .image-container {
  aspect-ratio: 375/790;
  padding-bottom: 0;
  top: 25px;
}
:host ::ng-deep .prev_next__content img {
  max-width: calc(100% - 17px);
  border-radius: 11px;
  scale: 0.96 0.96;
  transform: translate(-50%, -50%);
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 7px);
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}

@media only screen and (min-width: 780px) {
  .prev_next__contents .inline-flex > * {
    width: calc(50% - 30px);
    flex-basis: calc(50% - 30px);
    max-width: 375px;
  }
}
.prev_next__contents .prev_next__content:not(.active) {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/comparaison/comparaison.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;AACI;EACE,aAAA;AACN;AAII;EACE,2BAAA;AAFN;AAKI;EACE,aAAA;AAHN;AAMI;EACE,cAAA;AAJN;;AASA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AANF;AAQE;EACE,SAAA;AANJ;AAQI;EACE,UAAA;AANN;AAUE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AARJ;;AAaE;EACE,qBAAA;EACA,iBAAA;AAVJ;AAaE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAXJ;AAaI;EACE,qBAAA;EACA,iBAAA;EACA,SAAA;AAXN;AAcI;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAZN;;AAiBA;EACE;IACE,uBAAA;IACA,4BAAA;IACA,gBAAA;EAdF;AACF;AAiBA;EACE,aAAA;AAfF","sourcesContent":[".prev_next__headers {\r\n  text-align: center;\r\n  gap: 10px;\r\n  font-size: 18px;\r\n  margin-bottom: 3rem;\r\n\r\n  .prev_next__headers_container {\r\n    min-width: 150px;\r\n\r\n    > :not(.active) {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  svg {\r\n    &:hover {\r\n      color: var(--primary-color);\r\n    }\r\n\r\n    &:first-child {\r\n      rotate: 90deg;\r\n    }\r\n\r\n    &:last-child {\r\n      rotate: -90deg;\r\n    }\r\n  }\r\n}\r\n\r\n.prev_next__contents {\r\n  width: 100%;\r\n  text-align: center;\r\n  max-width: 720px;\r\n\r\n  > * {\r\n    gap: 40px;\r\n\r\n    .mobile-overlay {\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  .prev_next__content {\r\n    position: absolute;\r\n    z-index: 0;\r\n    inset: 0;\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  .mobile-overlay .image-container {\r\n    aspect-ratio: 375/848;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .prev_next__content {\r\n    position: absolute;\r\n    z-index: 0;\r\n    inset: 0;\r\n\r\n    .image-container {\r\n      aspect-ratio: 375/790;\r\n      padding-bottom: 0;\r\n      top: 25px;\r\n    }\r\n\r\n    img {\r\n      max-width: calc(100% - 17px);\r\n      border-radius: 11px;\r\n      scale: 0.96 0.96;\r\n      transform: translate(-50%, -50%);\r\n      position: absolute;\r\n      top: calc(50% - 15px);\r\n      left: calc(50% - 7px);\r\n      height: 100%;\r\n      border-radius: 20px;\r\n      overflow: hidden;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 780px) {\r\n  .prev_next__contents .inline-flex > * {\r\n    width: calc(50% - 30px);\r\n    flex-basis: calc(50% - 30px);\r\n    max-width: 375px;\r\n  }\r\n}\r\n\r\n.prev_next__contents .prev_next__content:not(.active) {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
